import { Link } from "react-router-dom";

/**
 * Compact "Related guide" link placed on a feature/use-case page to point at a
 * topically-matched blog post. Builds relevance-rich internal links between the
 * feature pages and the guides. English labels — the blog is English-only.
 */
export const RelatedGuide = ({ to, title, description }) => (
  <section className="py-4">
    <div className="container">
      <div className="col-lg-8 mx-auto">
        <Link
          to={to}
          className="card border-0 bg-purple-subtle text-decoration-none text-reset"
        >
          <div className="card-body p-4 d-flex align-items-center gap-3">
            <div className="icon icon-lg bg-white rounded-3 flex-shrink-0">
              <i className="bi bi-journal-text fs-4 text-purple"></i>
            </div>
            <div className="flex-grow-1">
              <span className="small fw-semibold text-purple">
                Related guide
              </span>
              <h3 className="h6 mb-0">{title}</h3>
              {description && (
                <p className="text-muted small mb-0 mt-1">{description}</p>
              )}
            </div>
            <i className="bi bi-arrow-right fs-5 text-purple flex-shrink-0"></i>
          </div>
        </Link>
      </div>
    </div>
  </section>
);

export default RelatedGuide;
